import { toSeconds, toHours, toMinutes, toDays, toMonths, toYears } from 'duration-fns';

var TERMS;
(function (TERMS) {
    TERMS["second"] = "second";
    TERMS["minute"] = "minute";
    TERMS["hour"] = "hour";
    TERMS["day"] = "day";
    TERMS["month"] = "month";
    TERMS["year"] = "year";
})(TERMS || (TERMS = {}));
const UNIT_TO_METHOD = {
    [TERMS.year]: toYears,
    [TERMS.month]: toMonths,
    [TERMS.day]: toDays,
    [TERMS.minute]: toMinutes,
    [TERMS.hour]: toHours,
    [TERMS.second]: toSeconds,
};
const STRING_TO_TERMS = {
    seconds: TERMS.second,
    minutes: TERMS.minute,
    hours: TERMS.hour,
    days: TERMS.day,
    months: TERMS.month,
    years: TERMS.year,
};
var DURATION;
(function (DURATION) {
    DURATION["seconds"] = "seconds";
    DURATION["minutes"] = "minutes";
    DURATION["hours"] = "hours";
    DURATION["days"] = "days";
    DURATION["months"] = "months";
    DURATION["years"] = "years";
})(DURATION || (DURATION = {}));
const STRING_TO_DURATION = {
    second: DURATION.seconds,
    minute: DURATION.minutes,
    hour: DURATION.hours,
    day: DURATION.days,
    month: DURATION.months,
    year: DURATION.years,
};

export { DURATION, STRING_TO_DURATION, STRING_TO_TERMS, TERMS, UNIT_TO_METHOD };
//# sourceMappingURL=termsAndDuration.js.map
